import React from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';

const CustomAnalysisSorter = ({ value, onValueChange }) => {
    return (
        <Select value={value} onValueChange={onValueChange}>
            <SelectTrigger className="w-48">
                <SelectValue placeholder="Sort by..." />
            </SelectTrigger>
            <SelectContent>
                <SelectItem value="created_desc" className="cursor-pointer">Newest first</SelectItem>
                <SelectItem value="created_asc" className="cursor-pointer">Oldest first</SelectItem>
                <SelectItem value="last_used_desc" className="cursor-pointer">Recently used</SelectItem>
                <SelectItem value="name_asc" className="cursor-pointer">Name (A-Z)</SelectItem>
            </SelectContent>
        </Select>
    );
};

export default CustomAnalysisSorter;